'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var legacy_Typography_Text = require('./Text.js');
var react = require('@emotion/react');
require('@styled-system/should-forward-prop');
require('styled-system');
require('@emotion/styled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["variant", "as"],
  _excluded2 = ["variant", "as"],
  _excluded3 = ["variant", "as"],
  _excluded4 = ["variant", "as"],
  _excluded5 = ["variant", "as"],
  _excluded6 = ["variant", "as"],
  _excluded7 = ["variant", "as"],
  _excluded8 = ["variant", "as"],
  _excluded9 = ["variant", "as"];
var Paragraph = /*#__PURE__*/React__default["default"].forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'paragraph8' : _ref$variant,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'p' : _ref$as,
    props = _objectWithoutProperties__default["default"](_ref, _excluded);
  return react.jsx(legacy_Typography_Text.Text, _extends__default["default"]({
    m: 0,
    variant: variant,
    as: as
  }, props, {
    ref: ref
  }));
});
/**
 * @deprecated This component is deprecated and will no longer receive functionality updates. Please avoid using it in new projects.
 * New version is available.
 * @see https://storybook.olxtech.pl/?path=/docs/typography-textcontainer--regular
 * @see https://storybook.olxtech.pl/?path=/docs/typography-paragraph--p-1-regular
 */
var Paragraph1 = /*#__PURE__*/React__default["default"].forwardRef(function (_ref2, ref) {
  var _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'paragraph1' : _ref2$variant,
    _ref2$as = _ref2.as,
    as = _ref2$as === void 0 ? 'p' : _ref2$as,
    props = _objectWithoutProperties__default["default"](_ref2, _excluded2);
  return react.jsx(legacy_Typography_Text.Text, _extends__default["default"]({
    m: 0,
    variant: variant,
    as: as
  }, props, {
    ref: ref
  }));
});
/**
 * @deprecated This component is deprecated and will no longer receive functionality updates. Please avoid using it in new projects.
 * New version is available.
 * @see https://storybook.olxtech.pl/?path=/docs/typography-textcontainer--regular
 * @see https://storybook.olxtech.pl/?path=/docs/typography-paragraph--p-2-regular
 */
var Paragraph2 = /*#__PURE__*/React__default["default"].forwardRef(function (_ref3, ref) {
  var _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'paragraph2' : _ref3$variant,
    _ref3$as = _ref3.as,
    as = _ref3$as === void 0 ? 'p' : _ref3$as,
    props = _objectWithoutProperties__default["default"](_ref3, _excluded3);
  return react.jsx(legacy_Typography_Text.Text, _extends__default["default"]({
    m: 0,
    variant: variant,
    as: as
  }, props, {
    ref: ref
  }));
});
/**
 * @deprecated This component is deprecated and will no longer receive functionality updates. Please avoid using it in new projects.
 * New version is available.
 * @see https://storybook.olxtech.pl/?path=/docs/typography-textcontainer--regular
 * @see https://storybook.olxtech.pl/?path=/docs/typography-paragraph--p-3-regular
 */
var Paragraph3 = /*#__PURE__*/React__default["default"].forwardRef(function (_ref4, ref) {
  var _ref4$variant = _ref4.variant,
    variant = _ref4$variant === void 0 ? 'paragraph3' : _ref4$variant,
    _ref4$as = _ref4.as,
    as = _ref4$as === void 0 ? 'p' : _ref4$as,
    props = _objectWithoutProperties__default["default"](_ref4, _excluded4);
  return react.jsx(legacy_Typography_Text.Text, _extends__default["default"]({
    m: 0,
    variant: variant,
    as: as
  }, props, {
    ref: ref
  }));
});
/**
 * @deprecated This component is deprecated and will no longer receive functionality updates. Please avoid using it in new projects.
 * New version is available.
 * @see https://storybook.olxtech.pl/?path=/docs/typography-textcontainer--regular
 * @see https://storybook.olxtech.pl/?path=/docs/typography-paragraph--p-4-regular
 */
var Paragraph4 = /*#__PURE__*/React__default["default"].forwardRef(function (_ref5, ref) {
  var _ref5$variant = _ref5.variant,
    variant = _ref5$variant === void 0 ? 'paragraph4' : _ref5$variant,
    _ref5$as = _ref5.as,
    as = _ref5$as === void 0 ? 'p' : _ref5$as,
    props = _objectWithoutProperties__default["default"](_ref5, _excluded5);
  return react.jsx(legacy_Typography_Text.Text, _extends__default["default"]({
    m: 0,
    variant: variant,
    as: as
  }, props, {
    ref: ref
  }));
});
/**
 * @deprecated This component is deprecated and will no longer receive functionality updates. Please avoid using it in new projects.
 * New version is available.
 * @see https://storybook.olxtech.pl/?path=/docs/typography-textcontainer--regular
 * @see https://storybook.olxtech.pl/?path=/docs/typography-paragraph--p-5-regular
 */
var Paragraph5 = /*#__PURE__*/React__default["default"].forwardRef(function (_ref6, ref) {
  var _ref6$variant = _ref6.variant,
    variant = _ref6$variant === void 0 ? 'paragraph5' : _ref6$variant,
    _ref6$as = _ref6.as,
    as = _ref6$as === void 0 ? 'p' : _ref6$as,
    props = _objectWithoutProperties__default["default"](_ref6, _excluded6);
  return react.jsx(legacy_Typography_Text.Text, _extends__default["default"]({
    m: 0,
    variant: variant,
    as: as
  }, props, {
    ref: ref
  }));
});
/**
 * @deprecated This component is deprecated and will no longer receive functionality updates. Please avoid using it in new projects.
 * New version is available.
 * @see https://storybook.olxtech.pl/?path=/docs/typography-textcontainer--regular
 */
var Paragraph6 = /*#__PURE__*/React__default["default"].forwardRef(function (_ref7, ref) {
  var _ref7$variant = _ref7.variant,
    variant = _ref7$variant === void 0 ? 'paragraph6' : _ref7$variant,
    _ref7$as = _ref7.as,
    as = _ref7$as === void 0 ? 'p' : _ref7$as,
    props = _objectWithoutProperties__default["default"](_ref7, _excluded7);
  return react.jsx(legacy_Typography_Text.Text, _extends__default["default"]({
    m: 0,
    variant: variant,
    as: as
  }, props, {
    ref: ref
  }));
});
/**
 * @deprecated This component is deprecated and will no longer receive functionality updates. Please avoid using it in new projects.
 * New version is available.
 * @see https://storybook.olxtech.pl/?path=/docs/typography-textcontainer--regular
 */
var Paragraph7 = /*#__PURE__*/React__default["default"].forwardRef(function (_ref8, ref) {
  var _ref8$variant = _ref8.variant,
    variant = _ref8$variant === void 0 ? 'paragraph7' : _ref8$variant,
    _ref8$as = _ref8.as,
    as = _ref8$as === void 0 ? 'p' : _ref8$as,
    props = _objectWithoutProperties__default["default"](_ref8, _excluded8);
  return react.jsx(legacy_Typography_Text.Text, _extends__default["default"]({
    m: 0,
    variant: variant,
    as: as
  }, props, {
    ref: ref
  }));
});
/**
 * @deprecated This component is deprecated and will no longer receive functionality updates. Please avoid using it in new projects.
 * New version is available.
 * @see https://storybook.olxtech.pl/?path=/docs/typography-textcontainer--regular
 */
var Paragraph8 = /*#__PURE__*/React__default["default"].forwardRef(function (_ref9, ref) {
  var _ref9$variant = _ref9.variant,
    variant = _ref9$variant === void 0 ? 'paragraph8' : _ref9$variant,
    _ref9$as = _ref9.as,
    as = _ref9$as === void 0 ? 'p' : _ref9$as,
    props = _objectWithoutProperties__default["default"](_ref9, _excluded9);
  return react.jsx(legacy_Typography_Text.Text, _extends__default["default"]({
    m: 0,
    variant: variant,
    as: as
  }, props, {
    ref: ref
  }));
});

exports.Paragraph = Paragraph;
exports.Paragraph1 = Paragraph1;
exports.Paragraph2 = Paragraph2;
exports.Paragraph3 = Paragraph3;
exports.Paragraph4 = Paragraph4;
exports.Paragraph5 = Paragraph5;
exports.Paragraph6 = Paragraph6;
exports.Paragraph7 = Paragraph7;
exports.Paragraph8 = Paragraph8;
//# sourceMappingURL=Paragraph.js.map
